var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$parent.content_type === 'image'),expression:"this.$parent.content_type === 'image'"}],staticClass:"uk-width-1-1 uk-cover-container",attrs:{"uk-height-viewport":""}},[_c('img',{class:_vm.isImage,attrs:{"id":"image","uk-cover":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }